import React from 'react';

const CustomStyles = ({ cssString }) => {
  // TODO validation of some kind. Though it should be from a trusted source, famous last words
  return cssString ? <style type="text/css">{cssString}</style> : null;
};

export default CustomStyles;
